<template>
  <a
    :href="resultUrl"
    :title="result.label"
    @click.stop
  >
    <img
      class="user-avatar image-circle"
      :src="result.avatar_url"
    >
    <span class="result-info">
      <DHighlightText
        class="result-label"
        :highlight="searchTerm"
        :text="result.label"
      />
      <span class="more-info">
        <DHighlightText
          class="username"
          :highlight="searchTerm"
          :text="result.username | duiUsername"
        />
        -
        <span>{{ result.user_type }}</span>
      </span>
    </span>
  </a>
</template>


<script>
import searchResultMixin from '../search-result-mixin';

export default {
  mixins: [
    searchResultMixin,
  ],
};
</script>


<style lang="scss" scoped>
@import "@dui-styles/base";

img.user-avatar {
  height: $_4em;
  width: $_4em;
}
</style>
